import * as React from 'react';
import { useEffect } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import {
  GenerateQuestionStep,
  shouldOpenAtStep2Atom,
  useScopedStepAtom,
} from '~teacher/components/QuizEditor/GenerateQuestionDialog/atom';

import { assertUnreachable } from '../../../../util/assertUnreachable';
import { useQuestionGenerator } from './context';
import { GenerateQuestionStep1 } from './GenerateQuestionStep1';
import { GenerateQuestionStep2 } from './GenerateQuestionStep2';

interface Props {
  onClose: () => void;
  refreshQuestions: () => Promise<void>;
  resetRef?: React.MutableRefObject<(() => void) | null>;
}
export function GenerateQuestion({
  onClose,
  refreshQuestions,
  resetRef,
}: Props) {
  const [currentStep, setCurrentStep] = useScopedStepAtom();
  const shouldOpenAtStep2 = useAtomValue(shouldOpenAtStep2Atom);
  const setShouldOpenAtStep2 = useSetAtom(shouldOpenAtStep2Atom);
  const questionGenerator = useQuestionGenerator();

  useEffect(() => {
    if (resetRef) {
      resetRef.current = () => questionGenerator.reset();
    }
  }, [resetRef, questionGenerator]);

  // Open step 2 when user click success toast link
  useEffect(() => {
    if (shouldOpenAtStep2) {
      setCurrentStep({ type: 'SetStep', step: GenerateQuestionStep.Questions });
      // Reset stale data
      questionGenerator.reset();
      // Reset the atom for next generation
      setShouldOpenAtStep2(false);
    }
  }, [
    shouldOpenAtStep2,
    setCurrentStep,
    setShouldOpenAtStep2,
    questionGenerator,
  ]);
  switch (currentStep) {
    case GenerateQuestionStep.Settings:
      return <GenerateQuestionStep1 />;
    case GenerateQuestionStep.Questions:
      return (
        <GenerateQuestionStep2
          onClose={onClose}
          refreshQuestions={refreshQuestions}
        />
      );
    default:
      assertUnreachable(currentStep);
  }
}
